import controller from '../../../../Scripts/Controller.js';
function CheckboxSorter(container) {

    function init() {
        function sortCheckboxes(container) {
            var amountVisibleEntries = container.dataset.checkboxsorterAmountvisibleentries;

            // Select all checkboxes within the container
            const allCheckboxes = Array.from(container.querySelectorAll('.checkbox'));

            // Sort all checkboxes by checked state, then alphabetically
            allCheckboxes.sort((a, b) => {
                const aChecked = a.querySelector('input[type="checkbox"]').checked;
                const bChecked = b.querySelector('input[type="checkbox"]').checked;
                const aLabel = a.querySelector('label').textContent.trim().toLowerCase();
                const bLabel = b.querySelector('label').textContent.trim().toLowerCase();

                if (aChecked === bChecked) {
                    return aLabel < bLabel ? -1 : aLabel > bLabel ? 1 : 0;
                }
                return aChecked ? -1 : 1;
            });

            // Find the adjusted cutoff for visible entries to ensure all checked checkboxes are visible
            const checkedCount = allCheckboxes.filter(cb => cb.querySelector('input[type="checkbox"]').checked).length;
            const adjustedVisibleEntries = Math.max(amountVisibleEntries, checkedCount);

            // Clear existing checkboxes before reattaching
            container.querySelectorAll('.visible-checkboxes, .toggle__area').forEach(area => area.innerHTML = '');

            // Reattach checkboxes based on the adjusted threshold
            const visibleContainer = container.querySelector('.visible-checkboxes');
            const toggleArea = container.querySelector('.toggle__area');
            allCheckboxes.forEach((checkbox, index) => {
                if (index < adjustedVisibleEntries) {
                    visibleContainer.appendChild(checkbox);
                } else {
                    toggleArea.appendChild(checkbox);
                }
            });
        }

        // Attach change event listener to container to sort checkboxes on change
        container.addEventListener('change', function (e) {
            if (e.target.type === 'checkbox') {
                sortCheckboxes(container);

            }
        });

        // Initial sort in case some checkboxes are initially checked
        sortCheckboxes(container);

    }



    return {
        init: init
    }

}

controller.add('CheckboxSorter', CheckboxSorter);
export default CheckboxSorter;